export function GreenhouseIcon() {
	return (
		<svg height="16" width="12.444" xmlns="http://www.w3.org/2000/svg">
			<path d="M12.149 4.834L6.47.093a.395.395 0 00-.509 0L.284 4.833A.789.789 0 000 5.435v6.62c0 .165.106.312.26.371l4.184 1.5v1.292c0 .436.347.783.779.783.384 0 .698-.4.698-.783V9.716a.196.196 0 00-.196-.194h-.189c-.603 0-1.088.836-1.088 2.261l-.004.5c-.2-.064-.38-.117-.528-.17-1.077-.353-2.13-1.23-2.13-2.485 0-2.933 3.194-6.249 4.164-7.185a.398.398 0 01.55 0c.97.936 4.164 4.252 4.164 7.185 0 1.254-1.053 2.132-2.13 2.485-.218.07-.839.253-1.147.353l.012.819c0 .406.408.689.793.554l3.992-1.42a.388.388 0 00.26-.37V5.433a.842.842 0 00-.295-.6z" />
		</svg>
	);
}
